'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YesNo = exports.LinkIcon = exports.XsBr = exports.SrOnly = exports.ContainerDivs = exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class2, _class3, _temp, _dec3, _class4, _dec4, _class5, _class6, _temp2, _dec5, _class7, _class8, _temp3;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Utility = require('./Utility.css');

var _Utility2 = _interopRequireDefault(_Utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {Row, Col} from 'react-flexbox-grid'
// import config from '../../config'
// import { Link } from '../'

var ContainerDivs = (_dec = (0, _reactCssModules2.default)(_Utility2.default, { allowMultiple: false }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ContainerDivs, _Component);

  function ContainerDivs() {
    (0, _classCallCheck3.default)(this, ContainerDivs);
    return (0, _possibleConstructorReturn3.default)(this, (ContainerDivs.__proto__ || (0, _getPrototypeOf2.default)(ContainerDivs)).apply(this, arguments));
  }

  (0, _createClass3.default)(ContainerDivs, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'c' },
        _react2.default.createElement(
          'div',
          { styleName: 'ci' },
          this.props.children
        )
      );
    }
  }]);
  return ContainerDivs;
}(_react.Component)) || _class);
var SrOnly = (_dec2 = (0, _reactCssModules2.default)(_Utility2.default, { allowMultiple: false }), _dec2(_class2 = (_temp = _class3 = function (_Component2) {
  (0, _inherits3.default)(SrOnly, _Component2);

  function SrOnly(props) {
    (0, _classCallCheck3.default)(this, SrOnly);
    return (0, _possibleConstructorReturn3.default)(this, (SrOnly.__proto__ || (0, _getPrototypeOf2.default)(SrOnly)).call(this, props));
  }

  (0, _createClass3.default)(SrOnly, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { styleName: 'sr-only' },
        this.props.children
      );
    }
  }]);
  return SrOnly;
}(_react.Component), _class3.propTypes = {}, _temp)) || _class2);
var XsBr = (_dec3 = (0, _reactCssModules2.default)(_Utility2.default, { allowMultiple: false }), _dec3(_class4 = function (_Component3) {
  (0, _inherits3.default)(XsBr, _Component3);

  function XsBr() {
    (0, _classCallCheck3.default)(this, XsBr);
    return (0, _possibleConstructorReturn3.default)(this, (XsBr.__proto__ || (0, _getPrototypeOf2.default)(XsBr)).apply(this, arguments));
  }

  (0, _createClass3.default)(XsBr, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('br', { styleName: 'visible-xs' });
    }
  }]);
  return XsBr;
}(_react.Component)) || _class4);
var LinkIcon = (_dec4 = (0, _reactCssModules2.default)(_Utility2.default, { allowMultiple: false }), _dec4(_class5 = (_temp2 = _class6 = function (_Component4) {
  (0, _inherits3.default)(LinkIcon, _Component4);

  function LinkIcon(props) {
    (0, _classCallCheck3.default)(this, LinkIcon);
    return (0, _possibleConstructorReturn3.default)(this, (LinkIcon.__proto__ || (0, _getPrototypeOf2.default)(LinkIcon)).call(this, props));
  }

  (0, _createClass3.default)(LinkIcon, [{
    key: 'render',
    value: function render() {
      var nospace = this.props.nospace || false;
      var faclass = this.props.faclass || 'fa-angle-double-right';
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', {
          styleName: nospace ? null : 'space-left',
          className: 'fa ' + faclass
        })
      );
    }
  }]);
  return LinkIcon;
}(_react.Component), _class6.propTypes = {
  nospace: _react.PropTypes.bool,
  faclass: _react.PropTypes.string
}, _temp2)) || _class5);
var YesNo = (_dec5 = (0, _reactCssModules2.default)(_Utility2.default), _dec5(_class7 = (_temp3 = _class8 = function (_Component5) {
  (0, _inherits3.default)(YesNo, _Component5);

  function YesNo(props) {
    (0, _classCallCheck3.default)(this, YesNo);
    return (0, _possibleConstructorReturn3.default)(this, (YesNo.__proto__ || (0, _getPrototypeOf2.default)(YesNo)).call(this, props));
  }

  (0, _createClass3.default)(YesNo, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('i', {
        styleName: this.props.yes ? 'yes' : 'no',
        className: 'fa ' + (this.props.yes ? 'fa-check-circle' : 'fa-times')
      });
    }
  }]);
  return YesNo;
}(_react.Component), _class8.propTypes = {
  yes: _react.PropTypes.bool.isRequired
}, _temp3)) || _class7);
exports.default = YesNo;
exports.ContainerDivs = ContainerDivs;
exports.SrOnly = SrOnly;
exports.XsBr = XsBr;
exports.LinkIcon = LinkIcon;
exports.YesNo = YesNo;


//////////////////
// WEBPACK FOOTER
// ./src/core/Utility/Utility.js
// module id = 1397
// module chunks = 0